export enum PondStatus {
  active = 'active',
  inactive = 'inactive',
}

export interface PondState {
  statusDate: string;
  ponds: Pond[];
}

export enum ServiceSetupType {
  FEEDERS = 'Feeders',
  AERATORS = 'Aerators',
}

export interface Pond {
  pondId: string;
  siteId: string;
  zoneId: string;
  pondName: string;
  siteName: string;
  zoneName: string;
  createdBy: string;

  // seacloud fields
  pondStatus: PondStatus;
  activeInactiveDays: number;
  allowStocking: boolean;
  allowTransfer: boolean;
  allowHarvest: boolean;
  allowOtherRegistrations: boolean;

  // lock status
  lockCreatedBy: string;
  lockExpiresIn: string | null;

  // aerators and feeders
  totalNrOfAerators: number;
  totalAeratorSupportedBiomass: number;
  totalNrOfFeeders: number;
  totalBiomassFeedingCapacity: number;
  totalBiomassInKg: number;
  aeratorSupportedBiomassPercentage: number;
  feederSupportedBiomassPercentage: number;
}
